
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English namespaces
import enCommon from './locales/en/common.json';
import enHomepage from './locales/en/homepage.json';
import enAbout from './locales/en/about.json';
import enDashboard from './locales/en/dashboard.json';
import enExplore from './locales/en/explore.json';
import enAuth from './locales/en/auth.json';
import enPricing from './locales/en/pricing.json';
import enSubmitListing from './locales/en/submitListing.json';
import enNotFound from './locales/en/notFound.json';

// Import Traditional Chinese namespaces
import zhTWCommon from './locales/zh-TW/common.json';
import zhTWHomepage from './locales/zh-TW/homepage.json';
import zhTWAbout from './locales/zh-TW/about.json';
import zhTWDashboard from './locales/zh-TW/dashboard.json';
import zhTWExplore from './locales/zh-TW/explore.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWPricing from './locales/zh-TW/pricing.json';
import zhTWSubmitListing from './locales/zh-TW/submitListing.json';
import zhTWNotFound from './locales/zh-TW/notFound.json';

// Import Simplified Chinese namespaces
import zhCNCommon from './locales/zh-CN/common.json';
import zhCNHomepage from './locales/zh-CN/homepage.json';
import zhCNAbout from './locales/zh-CN/about.json';
import zhCNDashboard from './locales/zh-CN/dashboard.json';
import zhCNExplore from './locales/zh-CN/explore.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import zhCNPricing from './locales/zh-CN/pricing.json';
import zhCNSubmitListing from './locales/zh-CN/submitListing.json';
import zhCNNotFound from './locales/zh-CN/notFound.json';

const isBrowser = typeof window !== 'undefined';

const resources = {
  en: {
    common: enCommon,
    homepage: enHomepage,
    about: enAbout,
    dashboard: enDashboard,
    explore: enExplore,
    auth: enAuth,
    pricing: enPricing,
    submitListing: enSubmitListing,
    notFound: enNotFound
  },
  'zh-TW': {
    common: zhTWCommon,
    homepage: zhTWHomepage,
    about: zhTWAbout,
    dashboard: zhTWDashboard,
    explore: zhTWExplore,
    auth: zhTWAuth,
    pricing: zhTWPricing,
    submitListing: zhTWSubmitListing,
    notFound: zhTWNotFound
  },
  'zh-CN': {
    common: zhCNCommon,
    homepage: zhCNHomepage,
    about: zhCNAbout,
    dashboard: zhCNDashboard,
    explore: zhCNExplore,
    auth: zhCNAuth,
    pricing: zhCNPricing,
    submitListing: zhCNSubmitListing,
    notFound: zhCNNotFound
  }
};

i18n
  .use(initReactI18next);

if (isBrowser) {
  i18n.use(LanguageDetector);
}

void i18n.init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    // Configure namespaces
    ns: ['common', 'homepage', 'about', 'dashboard', 'explore', 'auth', 'pricing', 'submitListing', 'notFound'],
    defaultNS: 'common',

    ...(isBrowser
      ? {
          detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
          },
        }
      : {}),

    interpolation: {
      escapeValue: false,
    },
    
    // Enable fallback to default namespace if key not found
    fallbackNS: 'common',
  });

export default i18n;
